export const INSPECTION_CALENDAR_URL =
  'https://crescocapitalgroup.my.salesforce-sites.com/InspectionCalendar'

export function getInspectionCalendarHref(): string {
  return INSPECTION_CALENDAR_URL
}
